import $ from "jquery";
import Base from "@patternslib/patternslib/src/core/base";
import registry from "@patternslib/patternslib/src/core/registry";
import _ from "underscore";


export default Base.extend({
  name: 'tceq-event-view',
  trigger: '.pat-tceq-event-view',
  parser: 'mockup',
  defaults: {},
  loading: 0,
  event_type: ["All events"],
  event_format: "Both",
  calendar_year: null,
  calendar_month: null,
  search_keywords: "",
  county_or_zip: [],
  start_date: null,
  end_date: null,

  updateStartEndDates: function() {
    const self = this;
    const startInput = self.el.querySelector('input[name="event.listing.start"]');
    const endInput = self.el.querySelector('input[name="event.listing.end"]');

    if (startInput) startInput.value = self.start_date || '';
    if (endInput) endInput.value = self.end_date || '';

    const calendarPlaceholder = self.el.querySelector('div#event-listing-calendar-placeholder');
    const events = calendarPlaceholder.querySelectorAll('td.event');

    // Remove existing classes (If any)
    events.forEach(eventCell => {
        eventCell.classList.remove(
            'event-listing-start-date',
            'event-listing-end-date',
            'event-listing-between-date'
        );
    });

    const startDate = self.start_date ? new Date(self.start_date) : null;
    const endDate = self.end_date ? new Date(self.end_date) : null;

    events.forEach(eventCell => {
        const link = eventCell.querySelector('a');
        if (!link) return;

        const dateString = link.getAttribute('data-date-string');
        const cellDate = new Date(dateString);

        if (startDate && cellDate.getTime() === startDate.getTime()) {
            // Matches start_date
            eventCell.classList.add('event-listing-start-date');
        } else if (endDate && cellDate.getTime() === endDate.getTime()) {
            // Matches end_date
            eventCell.classList.add('event-listing-end-date');
        } else if (
            startDate &&
            endDate &&
            cellDate > startDate &&
            cellDate < endDate
        ) {
            // Falls between start_date and end_date
            eventCell.classList.add('event-listing-between-date');
        }
    });

  },

  getUrlVars: function(url) {
      var vars = [], hash;
      var hashes = url.slice(url.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)
      {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
      }
      return vars;
  },

  getFilterValuesFromCookie: function() {
    const self = this;
    const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});

    self.event_type = cookies.event_type ? JSON.parse(cookies.event_type) : ["All events"];
    self.search_keywords = cookies.search_keywords ? cookies.search_keywords : "";
    self.event_format = cookies.event_format ? cookies.event_format : "Both";
    self.start_date = cookies.event_listing_start_date ? cookies.event_listing_start_date : null;
    self.end_date = cookies.event_listing_end_date ? cookies.event_listing_end_date : null;
  },

  checkEventTypes: function() {
    const self = this;
    const checkboxes = self.el.querySelectorAll('div#event-type-filter input[type="checkbox"]');

    checkboxes.forEach(checkbox => {
      if (self.event_type.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });
  },

  clearCookiesAndSetDefaults: function() {
    const self = this;

    document.cookie = `event_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `event_format=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `search_keywords=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `county_or_zip=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `event_listing_start_date=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `event_listing_end_date=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    self.event_type = ["All events"];
    self.event_format = "Both";
    self.calendar_year = null;
    self.calendar_month = null;
    self.search_keywords = "";
    self.county_or_zip = [];
    self.start_date = null;
    self.end_date = null;

    self.updateStartEndDates();
    self.checkEventTypes();

    const searchKeywordInput = self.el.querySelector('input#event-listing-search-keyword');
    if (searchKeywordInput) {
      searchKeywordInput.value = "";
    }

    const searchKeywordInputMobile = self.el.querySelector('input#event-listing-search-keyword-mobile');
    if (searchKeywordInputMobile) {
      searchKeywordInputMobile.value = "";
    }

    const countyOrZipInput = self.el.querySelector('input#event-listing-search-county-zip');
    if (countyOrZipInput) {
      countyOrZipInput.value = "";
      const select2Field = self.el.querySelectorAll('div#s2id_event-listing-search-county-zip ul.select2-choices li.select2-search-choice');
      select2Field.forEach(choice => {
        choice.remove();
      });
    }

    const countyOrZipInputMobile = self.el.querySelector('input#event-listing-search-county-zip-mobile');
    if (countyOrZipInputMobile) {
      countyOrZipInputMobile.value = "";
      const select2Field = self.el.querySelectorAll('div#s2id_event-listing-search-county-zip-mobile ul.select2-choices li.select2-search-choice');
      select2Field.forEach(choice => {
        choice.remove();
      });
    }

    const eventLocationFilter = self.el.querySelector('div#event-location-filter');
    if (eventLocationFilter) {
      const radioButtons = self.el.querySelectorAll('div#event-location-filter input[name="radioFilter"]');

      radioButtons.forEach(radio => {
          if (radio.value === self.event_format) {
              radio.checked = true;
          }
      });
    }

  },

  updateTypeOfEventsValues: function(checkboxes) {
    const self = this;
    self.event_type = Array.from(checkboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    document.cookie = `event_type=${encodeURIComponent(JSON.stringify(self.event_type))}; path=/;`;
  },

  updateEventFormatValue: function(value) {
    document.cookie = `event_format=${value}; path=/;`;
  },

  updateSearchKeywordsValues: function(mode) {
    const self = this;
    let input;
    if (mode === 'desktop'){
      input = self.el.querySelector('input#event-listing-search-keyword');
    } else if (mode === 'mobile'){
      input = self.el.querySelector('input#event-listing-search-keyword-mobile');
    } else {
      return;
    }
    self.search_keywords = input.value.trim();

    document.cookie = `search_keywords=${self.search_keywords}; path=/;`;
  },

  updateCountyOrZipValues: function(mode) {
    const self = this;
    let input;
    if (mode === 'desktop'){
      input = self.el.querySelector('input#event-listing-search-county-zip');
    } else if (mode === 'mobile'){
      input = self.el.querySelector('input#event-listing-search-county-zip-mobile');
    } else {
      return;
    }
    if (input.value !== ""){
      self.county_or_zip = input.value.split(',');
    } else {
      self.county_or_zip = [];
    }

    document.cookie = `county_or_zip=${encodeURIComponent(JSON.stringify(self.county_or_zip))}; path=/;`;
  },

  bindCheckboxEvents: function() {
    const self = this;
    const checkboxes = self.el.querySelectorAll('div#event-type-filter input[type="checkbox"]');
    const allEventsCheckbox = Array.from(checkboxes).find(cb => cb.value === "All events");

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            if (checkbox === allEventsCheckbox && checkbox.checked) {
                // Uncheck all other checkboxes if "All events" is checked
                checkboxes.forEach(cb => {
                    if (cb !== allEventsCheckbox) cb.checked = false;
                });
            } else if (checkbox !== allEventsCheckbox && checkbox.checked) {
                // Uncheck "All events" if any other checkbox is checked
                if (allEventsCheckbox) allEventsCheckbox.checked = false;
            } else if (Array.from(checkboxes).every(cb => !cb.checked)) {
                // Check "All events" if all other checkboxes are unchecked
                if (allEventsCheckbox) allEventsCheckbox.checked = true;
            }
            // Update the list of checked values
            self.updateTypeOfEventsValues(checkboxes);
            self.updateCalendar();
            self.updateEventsList();
        });
    });
  },

  updateCalendar: function() {
    const self = this;
    const url = new URL(window.location.origin + window.location.pathname + "/@@calendar_view");;

    self.event_type.forEach(event_type => url.searchParams.append("event_type", event_type));
    self.county_or_zip.forEach(county_or_zip => url.searchParams.append("county_or_zip", county_or_zip));

    if (self.calendar_month){
      url.searchParams.append("month", self.calendar_month);
    }

    if (self.calendar_year){
      url.searchParams.append("year", self.calendar_year);
    }

    if (self.event_format){
      url.searchParams.append("event_format", self.event_format);
    }

    if (self.search_keywords){
      url.searchParams.append("SearchableText", self.search_keywords);
    }

    self.showLoading();
    self.loading += 1;

    fetch(url.toString(), { method: "GET" })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(data => {
      const calendarPlaceholder = self.el.querySelector("div#event-listing-calendar-placeholder > div");
      if (calendarPlaceholder) {
        calendarPlaceholder.innerHTML = data;
        registry.scan(calendarPlaceholder);
      }
    })
    .catch(error => {
      console.error("Error fetching calendar data:", error);
    })
    .finally(() => {
      self.loading -= 1;
      if (self.loading == 0){
        self.hideLoading();
      }
      self.updateStartEndDates();
    });
  },

  updateEventsList: function() {
    const self = this;
    const url = new URL(window.location.origin + window.location.pathname + "/@@list_filtered_events");;

    self.event_type.forEach(event_type => url.searchParams.append("event_type", event_type));
    self.county_or_zip.forEach(county_or_zip => url.searchParams.append("county_or_zip", county_or_zip));

    if (self.event_format){
      url.searchParams.append("event_format", self.event_format);
    }

    if (self.search_keywords){
      url.searchParams.append("SearchableText", self.search_keywords);
    }

    if (self.start_date){
      url.searchParams.append("start_date", self.start_date);
    }

    if (self.end_date){
      url.searchParams.append("end_date", self.end_date);
    }

    self.showLoading();
    self.loading += 1;

    fetch(url.toString(), { method: "GET" })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(data => {
      const eventsListPlaceholder = self.el.querySelector("div#event-listing-events-placeholder > div");
      if (eventsListPlaceholder) {
        eventsListPlaceholder.innerHTML = data;
        registry.scan(eventsListPlaceholder);
      }
    })
    .catch(error => {
      console.error("Error fetching events listing data:", error);
    })
    .finally(() => {
      self.loading -= 1;
      if (self.loading == 0){
        self.hideLoading();
      }
    });
  },

  showLoading: function (){
    const self = this;
    const overlay = self.el.querySelector('.overlay');
    if (overlay){
      overlay.classList.add('show');
    }

  },

  hideLoading: function (){
    const self = this;
    self.updateFilterNumber();
    const overlay = self.el.querySelector('.overlay');
    if (overlay){
      overlay.classList.remove('show');
    }
  },

  updateFilterNumber: function (){
    const self = this;
    let number_of_filters = 0;

    function arraysAreEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1.every((value, index) => value === arr2[index]);
    }

    if (!arraysAreEqual(self.event_type, ["All events"])) {
      number_of_filters += 1;
    }
    if (self.event_format != "Both"){
      number_of_filters += 1;
    }
    if (self.search_keywords != ""){
      number_of_filters += 1;
    }
    if (!arraysAreEqual(self.county_or_zip, [])) {
      number_of_filters += 1;
    }
    if (self.start_date != null){
      number_of_filters += 1;
    }
    if (self.end_date != null){
      number_of_filters += 1;
    }

    const buttons = self.el.querySelectorAll('.clear-all-filters');

    buttons.forEach(button => {
        const baseText = button.getAttribute('data-base-text') || button.textContent.trim();
        button.textContent = `${baseText} (${number_of_filters})`;
        button.setAttribute('data-base-text', baseText);
    });
  },

  init: function() {
    const self = this;

    self.getFilterValuesFromCookie();

    const calendarPlaceholder = self.el.querySelector("div#event-listing-calendar-placeholder");
    if (calendarPlaceholder) {
      self.updateCalendar();
      calendarPlaceholder.addEventListener('click', (event) => {
        const target = event.target;

        if (target.tagName === 'A' && target.closest('td.event')) {
            event.preventDefault();
            const dateValue = target.getAttribute('data-date-string');

            if (!self.start_date && !self.end_date) {
                self.start_date = dateValue;
            } else if (self.start_date && !self.end_date) {
              const selectedDate = new Date(dateValue);
              const currentStartDate = new Date(self.start_date);

              if (selectedDate < currentStartDate) {
                  self.start_date = dateValue;
              } else {
                  self.end_date = dateValue;
              }
            } else {
                self.start_date = dateValue;
                self.end_date = null;
            }
            // Update cookies
            document.cookie = `event_listing_start_date=${self.start_date || ''}; path=/;`;
            document.cookie = `event_listing_end_date=${self.end_date || ''};path=/;`;

            self.updateStartEndDates();
            self.updateEventsList();
        }
      });
      calendarPlaceholder.addEventListener('click', function(event) {
        const target = event.target;
        // Check if the clicked element matches "td.cal_has_events a"
        if (target.matches("header.card-header a")) {
          if (target.dataset.year !== undefined){
            self.calendar_year = target.dataset.year;
          }
          if (target.dataset.month !== undefined){
            self.calendar_month = target.dataset.month;
          }
        }
      });
    }

    const eventsListPlaceholder = self.el.querySelector("div#event-listing-events-placeholder > div");
    if (eventsListPlaceholder) {
      self.updateEventsList();
    }

    const checkboxes = self.el.querySelectorAll('div#event-type-filter input[type="checkbox"]');
    if (checkboxes) {
      self.checkEventTypes();
      self.bindCheckboxEvents();
    }

    const searchKeywordInput = self.el.querySelector('input#event-listing-search-keyword');
    if (searchKeywordInput) {
      searchKeywordInput.value = self.search_keywords;
      searchKeywordInput.addEventListener('keydown', (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            self.updateSearchKeywordsValues('desktop');
            self.updateCalendar();
            self.updateEventsList();
        }
      });
    }

    const searchKeywordInputMobile = self.el.querySelector('input#event-listing-search-keyword-mobile');
    if (searchKeywordInputMobile) {
      searchKeywordInputMobile.value = self.search_keywords;
      searchKeywordInputMobile.addEventListener('keydown', (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            self.updateSearchKeywordsValues('mobile');
            self.updateCalendar();
            self.updateEventsList();
        }
      });
    }

    const searchCountyOrZipInput = self.el.querySelector('input#event-listing-search-county-zip');
    if (searchCountyOrZipInput) {
      $(searchCountyOrZipInput).on('selected', function (event) {
        self.updateCountyOrZipValues('desktop');
        self.updateCalendar();
        self.updateEventsList();
      });
    }

    const searchCountyOrZipInputMobile = self.el.querySelector('input#event-listing-search-county-zip-mobile');
    if (searchCountyOrZipInputMobile) {
      $(searchCountyOrZipInputMobile).on('selected', function (event) {
        self.updateCountyOrZipValues('mobile');
        self.updateCalendar();
        self.updateEventsList();
      });
    }

    const eventLocationFilter = self.el.querySelector('div#event-location-filter');
    if (eventLocationFilter) {
      const radioButtons = self.el.querySelectorAll('div#event-location-filter input[name="radioFilter"]');

      radioButtons.forEach(radio => {

          if (radio.value === self.event_format) {
              radio.checked = true;
          }

          radio.addEventListener('change', (event) => {
              if (event.target.checked) {
                  self.event_format = event.target.value; // Update self.event_format with the selected value
                  self.updateEventFormatValue(self.event_format);
                  self.updateCalendar();
                  self.updateEventsList();
              }
          });
      });
    }

    const filterEventsButton = self.el.querySelector('button#do-filter-events');
    if (filterEventsButton) {
      filterEventsButton.addEventListener('click', (event) => {
        self.updateSearchKeywordsValues('desktop');
        self.updateCountyOrZipValues('desktop');
        self.updateCalendar();
        self.updateEventsList();
      });
    }

    const filterEventsButtonMobile = self.el.querySelector('button#do-filter-events-mobile');
    if (filterEventsButtonMobile) {
      filterEventsButtonMobile.addEventListener('click', (event) => {
        self.updateSearchKeywordsValues('mobile');
        self.updateCountyOrZipValues('mobile');
        self.updateCalendar();
        self.updateEventsList();
      });
    }

    const clearFiltersButtons = self.el.querySelectorAll('button.clear-all-filters');
    if (clearFiltersButtons){
      clearFiltersButtons.forEach(btn => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          self.clearCookiesAndSetDefaults();
          self.updateCalendar();
          self.updateEventsList();
        });
      });
    }

    self.el.addEventListener('click', function(event) {
      // Check if the clicked element is the button with the class
      if (event.target.classList.contains('clear-filter-dates')) {
        event.preventDefault();
        document.cookie = `event_listing_start_date=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        document.cookie = `event_listing_end_date=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        self.start_date = null;
        self.end_date = null;
        self.updateStartEndDates();
        self.updateEventsList();
      };
    });

    const startInput = self.el.querySelector('input[name="event.listing.start"]');
    startInput.addEventListener('change', (event) => {
      event.preventDefault();
      self.start_date = event.target.value;
      // Update cookies
      document.cookie = `event_listing_start_date=${self.start_date || ''}; path=/;`;
      self.updateStartEndDates();
      self.updateEventsList();
    });

    const endInput = self.el.querySelector('input[name="event.listing.end"]');
    endInput.addEventListener('change', (event) => {
      event.preventDefault();
      self.end_date = event.target.value;
      // Update cookies
      document.cookie = `event_listing_end_date=${self.end_date || ''};path=/;`;
      self.updateStartEndDates();
      self.updateEventsList();
    });
  }

});
